import sx from "../styles/pages/journeys/JourneysPage.module.css";
import { CALCULATOR_MODE, JourneyDataType } from "../@types/travel";
import { IconButton } from "./icon-button";
import { AddIcon, CloseIcon } from "../utils/icons";
import { AppButton } from "./app-button";
import { IFlightLeg } from "../@interfaces/quote.interface";

const getIconByType = (element: any) => {
  const methods = [ element?.type, element?.transportMethod ];
  if (methods.includes('FLIGHT')) return 'https://res.cloudinary.com/carbonclick/image/upload/v1681309394/widgets/Journey%20Widget/airplanemode_nb9qha.svg';
  if (methods.includes('PUBLIC')) return 'https://res.cloudinary.com/carbonclick/image/upload/v1681309394/widgets/Journey%20Widget/directions_railway_qus9js.svg';
  if (methods.includes('CAR')) return 'https://res.cloudinary.com/carbonclick/image/upload/v1681309394/widgets/Journey%20Widget/car_hjwtvq.svg';
  else return 'https://res.cloudinary.com/carbonclick/image/upload/v1681309394/widgets/Journey%20Widget/motorbike_uf7bgh.svg';
};

interface Props {
  list: any[];
  deleteQuote: (id: string) => void;
  setActiveStep: (step: number) => void;
}

const JourneysList: React.FC<Props> = ({ list, deleteQuote, setActiveStep }) => {

  // If more then 2 flights, show origin from first and destination from last
  const getFlightData = (element: { flights: IFlightLeg[]; mode: CALCULATOR_MODE }): IFlightLeg[] | undefined  => {
    if (!element?.flights?.length) return;
    
    const flights = element?.flights;

    if (!Array.isArray(flights) || flights.length === 0) return [];

    if (flights.length >= 2 && element.mode === CALCULATOR_MODE.multicity) {
      const { origin, cabinClass } = flights[0];
      const { destination } = flights[flights.length - 1];

      return [{ origin, destination, cabinClass }];
    } else {
      return flights.slice(0, 1);
    }
  };

  return (
    <div>
      {list?.map((element, index) => {
        const data = ((typeof element?.activityMetadata === "string") && JSON.parse(element?.activityMetadata)?.travels) || element?.activityMetadata?.travels || getFlightData(element) || [null];

        return data?.map((item: JourneyDataType, idx: number) => {
          return (
            <ListRow key={idx} idx={index} item={item} element={element} deleteQuote={deleteQuote} />
          );
        });
      })}

      <AppButton
        onClick={() => setActiveStep(0)}
        variant="outline"
        style={{ fontWeight: 600, display: 'flex', margin: '0 0 0 auto' }}
        startIcon={<AddIcon />}
      >
        Add another
      </AppButton>
    </div>
  );
};

interface ListRowProps {
  idx: number;
  item: any;
  element: any;
  deleteQuote: (id: string) => void;
}

const ListRow: React.FC<ListRowProps> = ({ idx, item, element, deleteQuote }) => {
  const icon = getIconByType(element);

  const upFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const originName = item?.origin?.split(",")[0];
  const destinationName = item?.destination?.split(",")[0];

  const distance = (element?.distance?.value && Math.round(element?.distance?.value)?.toLocaleString())
                || (element?.estimate?.distanceCovered && Math.round(element?.estimate?.distanceCovered)?.toLocaleString());

  const duration = (item?.duration && Math.round(item?.duration)?.toLocaleString())

  return (
    <div className={sx.listItem}>
      <div className={sx["listItem-content"]}>

      <div className={sx.subtitle} style={{ whiteSpace: 'nowrap' }}>Stage {idx + 1}:</div>

        <div className={sx.distance}>
          <div className={sx['row-width']}>
            <p
              className={`
                color-primary
                no-translate
                ${originName?.length === 3 ? sx.airportCode : sx.originName}
              `}
              style={{ fontWeight: originName?.length === 3 ? 700 : 600 }}
            >
              {originName && (originName === 3 ? originName?.toUpperCase() : upFirstLetter(originName))}
            </p>
            <p className={`${sx.subtitle} no-translate`}>
              {item?.origin?.substring(item?.origin.lastIndexOf(",") + 1)?.toUpperCase()}
            </p>
          </div>

          <div className={sx.horizontal_dotted_line}>
            {originName && <span className={sx.line}></span> }
            <div>
              <img width="30" height="30" src={icon} alt="journies icon" />
              <p style={{ fontSize: 10, textTransform: 'uppercase', fontWeight: 600 }}>{element?.mode}</p>
            </div>
            {destinationName && <span className={sx.line}></span> }
          </div>

          <div className={sx['row-width']}>
            <p
              className={`
                color-primary
                no-translate
                ${destinationName?.length === 3 ? sx.airportCode : sx.originName}
              `}
              style={{ fontWeight: destinationName?.length === 3 ? 700 : 600 }}
            >
              {destinationName && (destinationName === 3 ? destinationName?.toUpperCase() : upFirstLetter(destinationName))}
            </p>
            <p className={`${sx.subtitle} no-translate`}>
              {item?.destination?.substring(item?.destination.lastIndexOf(",") + 1)?.toUpperCase()}
            </p>
          </div>
        </div>

        <div className={sx['emissions-wrapper']}>
          <p className={`${sx.emissions} uppercase fw-700`}>
            Emissions:{' '}
            <span style={{ textTransform: 'lowercase' }}>
              {Math.round(element?.estimate?.co2eQuantity || element.co2Quantity)?.toLocaleString()}{' '}
              {element?.estimate?.co2eQuantityUnit || 'kg'}
            </span>
          </p>
          {(distance && <p className={`${sx.emissions} uppercase fw-700`}>
            Distance:{' '}
            <span style={{ textTransform: 'lowercase' }}>
              {distance}{' '}
              {element?.distance?.unit || element?.estimate?.distanceUnit}
            </span>
          </p>) || (duration && <p className={`${sx.emissions} uppercase fw-700`}>
            Duration:{' '}
            <span style={{ textTransform: 'lowercase' }}>
              {duration}{' h'}
            </span>
          </p>)}
        </div>

      </div>

      <IconButton
        icon={<CloseIcon />}
        onClick={() => deleteQuote(element?.estimate?.estimateId)}
      />
    </div>
  );
};

export default JourneysList;

